import { useTranslation } from 'react-i18next';
import { HistoryCategory } from './historyCategory';
import { ReportHistoryContainer } from './reportHistoryContainer';
import { GraphTypes, useReportsStore } from '../stores';
import { observer } from 'mobx-react-lite';
import { Parameters } from '@web/common';

export const FitnessReportHistory = observer(() => {
  const { t } = useTranslation(['common', 'reports', 'infoTexts']);
  const reportsStore = useReportsStore();

  return (
    <ReportHistoryContainer>
      <HistoryCategory
        parameters={[
          {
            type: GraphTypes.VALUE,
            parameter: Parameters.BODY_WEIGHT,
            unit: reportsStore.getParameterUnit(Parameters.BODY_WEIGHT),
            data: reportsStore.getValueParameterValues(Parameters.BODY_WEIGHT),
            infoText: t('infoTexts:body_weight_info'),
          },
          {
            type: GraphTypes.VALUE,
            parameter: Parameters.FAT_PERCENTAGE,
            parameter2: Parameters.FAT_MASS,
            unit: reportsStore.getParameterUnit(Parameters.FAT_PERCENTAGE),
            unit2: reportsStore.getParameterUnit(Parameters.FAT_MASS),
            data: reportsStore.getValueParameterValues(
              Parameters.FAT_PERCENTAGE,
              Parameters.FAT_MASS,
            ),
            infoText: t('infoTexts:fat_info'),
          },
          {
            type: GraphTypes.VALUE,
            parameter: Parameters.MUSCLE_PERCENTAGE,
            parameter2: Parameters.MUSCLE_MASS,
            unit: reportsStore.getParameterUnit(Parameters.MUSCLE_PERCENTAGE),
            unit2: reportsStore.getParameterUnit(Parameters.MUSCLE_MASS),
            data: reportsStore.getValueParameterValues(
              Parameters.MUSCLE_PERCENTAGE,
              Parameters.MUSCLE_MASS,
            ),
            infoText: t('infoTexts:muscle_info'),
          },
          {
            type: GraphTypes.VALUE,
            parameter: Parameters.BODY_MASS_INDEX,
            unit: reportsStore.getParameterUnit(Parameters.BODY_MASS_INDEX),
            data: reportsStore.getValueParameterValues(
              Parameters.BODY_MASS_INDEX,
            ),
            infoText: t('infoTexts:bmi_info'),
          },
          {
            type: GraphTypes.VALUE,
            parameter: Parameters.PHYSICAL_FITNESS,
            unit: reportsStore.getParameterUnit(Parameters.PHYSICAL_FITNESS),
            data: reportsStore.getValueParameterValues(
              Parameters.PHYSICAL_FITNESS,
            ),
            infoText: t('infoTexts:physical_fitness_info'),
          },
        ]}
        maxWidth={1000}
      />
    </ReportHistoryContainer>
  );
});
